module.exports = {
  baseUrl: "https://api-v4.staging.primrose.health",
  ClinicBaseUrl:"https://api-v4.staging.primrose.health",
  systemName: "System dev",
};
